import { useEffect, useState } from 'react';
import { UseFetchStatesType } from '../lib/types/types';
import GetRecords from '../lib/api/GetRecords';
import { APIS } from '../lib/constants/apis';
import { getFieldNamefromDataPath, removeDataKeys, removeNullDeep } from '../utils/helper';
import { get } from 'lodash';
import GetRecord from '../lib/api/GetRecord';
import { getLocalstorageToken } from '../context/AuthHelper';
import POP_LEVEL from '../lib/api/Populations.json';

import Schema from '../lib/paths/portal45nachricht_FULL_Paths.json';
import PutRecord from '../lib/api/PutRecord';
const P = Schema.attributes;

function useFetchNachrichten(showCreateNachricht?: boolean, ordner?: string): UseFetchStatesType {
	const [loading, setLoading] = useState<boolean>(false);
	const [data, setData] = useState<any[] | null>(null);
	const [error, setError] = useState<string | null>(null);

	useEffect(() => {
		const fetchData = async () => {
			setLoading(true);
			try {
				const filter = {
					Allgemein_Ordner: ordner,
					Antragstellende: { id: { $eq: get(getLocalstorageToken(), 'organisationId') } },
				};
				const res = await GetRecords(APIS['Portal-Nachricht'], POP_LEVEL.portal45nachricht.TABLE, filter, [
					{ createdAt: 'desc' },
				]);
				const result: any[] = removeNullDeep(removeDataKeys(get(res, 'data', [])));
				setData(result);
			} catch (err: any) {
				console.error('ERROR Fetching Portal-Nachrichten', err);
				setError(err.message);
			} finally {
				setLoading(false);
			}
		};
		fetchData();
	}, [ordner, showCreateNachricht]);
	return { loading, data, error };
}
function useFetchnachrichtenStartSeite(): UseFetchStatesType {
	const [loading, setLoading] = useState<boolean>(false);
	const [data, setData] = useState<any[] | null>(null);
	const [error, setError] = useState<string | null>(null);

	useEffect(() => {
		const fetchData = async () => {
			setLoading(true);
			try {
				let filterOptions = {
					Antragstellende: { id: { $eq: get(getLocalstorageToken(), 'organisationId') } },
					Allgemein_Ordner: 'Posteingang',
					Allgemein_gelesen: 'false',
				};
				let sort = ['createdAt:desc'];
				let pagination = {
					start: 0,
					limit: 3,
					withCount: true,
				};
				let fields = [
					'id',
					getFieldNamefromDataPath(P.Allgemein_Betreff.path),
					getFieldNamefromDataPath(P.Allgemein_Inhalt.path),
					getFieldNamefromDataPath(P.Allgemein_Erstellt_Amum.path),
				];
				const res = await GetRecords(
					APIS['Portal-Nachricht'],
					POP_LEVEL.portal45nachricht.START_SEITE,
					filterOptions,
					sort,
					pagination,
					fields,
				);
				const result: any[] = removeNullDeep(removeDataKeys(get(res, 'data', [])));
				setData(result);
			} catch (err: any) {
				console.error('ERROR Fetching Portal-Nachrichten', err);
				setError(err.message);
			} finally {
				setLoading(false);
			}
		};
		fetchData();
	}, []);
	return { loading, data, error };
}

function useFetchNachrichtenDetails(id: number): UseFetchStatesType {
	const [loading, setLoading] = useState<boolean>(false);
	const [data, setData] = useState<any[]>([]);
	const [error, setError] = useState<string | null>(null);
	useEffect(() => {
		// Fetch data
		const fetchData = async () => {
			try {
				const res = await GetRecord(APIS['Portal-Nachricht'], id, POP_LEVEL.portal45nachricht.DETAILS_SEITE);
				if (res) {
					if (!get(res, 'data.Allgemein_gelesen', false)) {
						await PutRecord(APIS['Portal-Nachricht'], id, { data: { Allgemein_gelesen: true } });
					}
				}
				const result: any[] = removeNullDeep(removeDataKeys(get(res, 'data', [])));
				setData(result);
			} catch (err: any) {
				setError(err.message);
			} finally {
				setLoading(false);
			}
		};

		fetchData();
	}, [id]);

	return { loading, data, error };
}
export { useFetchNachrichten, useFetchnachrichtenStartSeite, useFetchNachrichtenDetails };
